"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Wrapper = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Switcher__Wrapper",
  componentId: "fxisg3-0"
})(function (props) {
  return (0, _styledComponents.css)(["> *{display:flex;flex-wrap:wrap;margin:calc((", " / 2) * -1);}> * > *{flex-grow:1;flex-basis:calc((", " - (100% - ", ")) * 999);margin:calc(", " / 2);}", ""], _units.globalSizes[props.gap], props.threshold, _units.globalSizes[props.gap], _units.globalSizes[props.gap], props.limit && (0, _styledComponents.css)(["> * >:nth-last-child(n + ", "),> * >:nth-last-child(n + ", ") ~ *{flex-basis:100%;}"], Number(props.limit) + 1, Number(props.limit) + 1));
});
/**
 *
 * The Switcher is a component which has two states - horizontal and vertical with a specific cut-point between them.
 * It is intrinsically responsive but offers a clearer "switch" of layouts than, say a cluster - which may have two children on one row and one on the second - the switcher meets a defined width (the '`threshold`') and changes the layout of all its children.
 *
 * The optional '`limit`' prop limits the maximum number of children which can be passed to the horizontal render of the component. (say you had a 'navigation' element which you wanted to render across the top of the screen - but it had too many children passed, meaning it could not fit on the page - if this limit is exceeded, the component always renders its vertical view.)
 *
 * (Resize the viewport horizontally (or use the `preview size` addon in the canvas view's toolbar) to see the Switcher do its thing) -
 *
 * For more background about the Switcher (and why we don't just do this with a media query) see here : <a href="https://heydonworks.com/article/the-flexbox-holy-albatross/" target="_blank">The Flexbox holy albatross</a>
 *
 */

var Switcher = function Switcher(_ref) {
  var children = _ref.children,
      className = _ref.className,
      element = _ref.element,
      limit = _ref.limit,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 'none' : _ref$gap,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? _units.globalSizes.measure : _ref$threshold,
      rest = _objectWithoutProperties(_ref, ["children", "className", "element", "limit", "gap", "threshold"]);

  return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
    className: className,
    element: element,
    threshold: threshold,
    gap: gap,
    limit: limit
  }, rest), /*#__PURE__*/_react["default"].createElement("div", null, children));
};

var _default = Switcher;
exports["default"] = _default;